import { LIVE_EDGE_THRESHOLD_IN_SECONDS } from "../constants";

export const seekTo = (
  mediaElement: HTMLVideoElement | HTMLAudioElement,
  newCurrentTime: number
) => {
  mediaElement.currentTime = newCurrentTime;
};

export const seekFor = (
  mediaElement: HTMLVideoElement | HTMLAudioElement,
  amount: number
) => {
  seekTo(mediaElement, mediaElement.currentTime + amount);
};

export const seekToLiveEdge = (
  mediaElement: HTMLVideoElement | HTMLAudioElement
) => {
  if (mediaElement.seekable.length > 0) {
    const liveEdge =
      mediaElement.seekable.end(0) - LIVE_EDGE_THRESHOLD_IN_SECONDS;
    if (mediaElement.currentTime < liveEdge) {
      seekTo(mediaElement, liveEdge);
    }
  }
};
